import React from 'react';
import { formatDateTimeLong } from '../../utils/profileHelpers';

export default function ReturnReplaceModal({
  type,
  item,
  order,
  isOpen,
  reason,
  setReason,
  isSubmitting,
  submitError,
  onSubmit,
  onClose
}) {
  if (!isOpen) return null;

  const isReturn = type === 'return';
  const buttonText = isReturn ? 'Submit' : 'Submit';
  const canSubmit = order.status === 'Delivered' && item.status === 'Active';
  const statusDateMap = {
    'Return Requested': 'return_requested_at',
    'Return Approved': 'return_approved_at',
    'Returned': 'returned_at',
    'Refunded': 'refunded_at',
    'Replacement Requested': 'replacement_requested_at',
    'Replacement Approved': 'replacement_approved_at',
    'Replaced': 'replaced_at'
  };
  const statusDate = item && statusDateMap[item.status] ? item[statusDateMap[item.status]] : null;

  return (
    <div className="panda-modal-overlay" onClick={() => !isSubmitting && onClose()}>
      <div className="panda-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="panda-modal-header">
          <h3>{isReturn ? 'Return Request' : 'Replacement Request'}</h3>
          <button className="close-btn" onClick={onClose} disabled={isSubmitting}>
            <i className="ph ph-x"></i>
          </button>
        </div>

        <div className="panda-modal-body">
          <div className="item-info">
            <p><strong>Product:</strong> {item.product_type_name}</p>
            <p><strong>Material:</strong> {item.material_name}</p>
            <p><strong>Quantity:</strong> {item.quantity}</p>
          </div>

          {canSubmit ? (
            <>
              <textarea
                rows={4}
                placeholder={`Enter reason for ${isReturn ? 'return' : 'replacement'}`}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                disabled={isSubmitting}
                maxLength={500}
                aria-label={`Reason for ${isReturn ? 'return' : 'replacement'}`}
                className="form-control"
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #e5e7eb' }}
              />
              <small className="char-count">{reason.length}/500 characters</small>
              {submitError && (
                <p className="error-text">
                  <i className="ph ph-warning-circle"></i> {submitError}
                </p>
              )}
            </>
          ) : (
            <div className="item-status-timeline" style={{ marginTop: 16, textAlign: 'center' }}>
              <div style={{ fontWeight: 600, color: '#7b47ff', fontSize: '1.07em' }}>
                {order.status !== 'Delivered'
                  ? 'Item return/replacement not available because order is not delivered yet.'
                  : `Current status: ${item.status}`}
              </div>
              {statusDate && (
                <div className="status-date" style={{ marginTop: 4, color: '#6c7e99', fontSize: '.98em' }}>
                  Date: {formatDateTimeLong(statusDate)}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Updated Modal Footer with Bootstrap Grid for Alignment */}
        <div className="panda-modal-footer">
          <div className="container-fluid">
            <div className="row g-2 justify-content-end">
              <div className="col-auto">
                <button 
                  className="btn btn-secondary px-4" 
                  onClick={onClose} 
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
              </div>
              {canSubmit && (
                <div className="col-auto">
                  <button
                    className={`btn ${isReturn ? 'btn-warning' : 'btn-info'} px-4`}
                    onClick={onSubmit}
                    disabled={isSubmitting || !reason.trim()}
                  >
                    {isSubmitting ? 'Submitting...' : buttonText}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
